import { Modal } from "react-bootstrap";
import { RiCloseLargeFill } from "react-icons/ri";
import { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import {
  MdVisibility,
  MdVisibilityOff,
} from "react-icons/md";
import OutletUsersServices from "../../../services/OutletUsersServices";

// Validation Schema
const loginValidationSchema = Yup.object().shape({
  name: Yup.string().required("Full name is required"),
  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
    .required("Mobile number is required"),
  username: Yup.string()
    .min(3, "User name must be at least 3 characters long")
    .required("User name is required"),
  password: Yup.string()
    .min(3, "Password must be at least 3 characters long")
    .required("Password is required"),
  nike_name: Yup.string().required("Nick name is required"),
  location: Yup.string().required("Location is required"),
});

const AddOutletUserModal = (props) => {
  const { modalIsOpen, setIsOpen, getAllOutletUserData } = props;

  const outletSerApi = new OutletUsersServices();

  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    name: "",
    mobile: "",
    username: "",
    password: "",
    nike_name: "",
    location: "",
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      show={modalIsOpen}
      onHide={closeModal}
      backdrop="static"
      className="custom-modal"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={loginValidationSchema}
        onSubmit={(values, { setSubmitting }) => {
          setIsLoading(true);
          setLoginError("");
          const payload = {
            username: values?.username,
            password: values?.password,
            nike_name: values?.nike_name,
            name: values?.name,
            mobile: values?.mobile,
            location: values?.location,
          };
          outletSerApi
            .addOutletUserData(payload)
            .then((response) => {
              if (response.isSuccess) {
                toast.success(response.message);
                closeModal();
                getAllOutletUserData();
              } else {
                toast.error(response.message);
              }
            })
            .catch((error) => {
              console.error("Error addOutletUserData:", error);
              toast.dismiss();
              toast.error("Error add outlet user.");
            })
            .finally(() => {
              setIsLoading(false);
              setSubmitting(false);
              setLoginError("");
            });
        }}
      >
        {({ errors, touched, isSubmitting, setFieldValue }) => (
          <Form className="addAdmin-form">
            <div className={"modal-header pb-0 pt-2"}>
              <h5 className="modal-title">Add Outlet</h5>
              <button type="button" className={"btn"} onClick={closeModal}>
                <RiCloseLargeFill />
              </button>
            </div>
            <Modal.Body className="modal-body-scroll">
              <div className="form-group mb-2">
                <label htmlFor="name" className="form-label mb-0">
                  Full Name <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Field
                    type="name"
                    id="name"
                    name="name"
                    placeholder="Enter your name"
                    className={`form-input ${errors.name && touched.name ? "input-error" : ""}`}
                  />
                </div>
                <ErrorMessage name="name">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>
              <div className="form-group mb-2">
                <label htmlFor="mobile" className="form-label mb-0">
                  Mobile Number <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Field
                    type="mobile"
                    id="mobile"
                    name="mobile"
                    placeholder="Enter your mobile number"
                    className={`form-input ${errors.mobile && touched.mobile ? "input-error" : ""}`}
                    onChange={(e) => {
                      const value = e.target.value;
                      const sanitizedValue = value.replace(/[^0-9]/g, "");
                      setFieldValue("mobile", sanitizedValue);
                      e.preventDefault();
                    }}
                  />
                </div>
                <ErrorMessage name="mobile">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>
              <div className="form-group mb-2">
                <label htmlFor="username" className="form-label mb-0">
                  User Name <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Field
                    type="username"
                    id="username"
                    name="username"
                    placeholder="Enter your user name"
                    className={`form-input ${errors.username && touched.username ? "input-error" : ""}`}
                  />
                </div>
                <ErrorMessage name="username">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>

              {/* Password Field */}
              <div className="form-group mb-2">
                <label htmlFor="password" className="form-label mb-0">
                  Password <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Field
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    placeholder="Enter your password"
                    className={`form-input ${errors.password && touched.password ? "input-error" : ""}`}
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)}
                    tabIndex="-1"
                    title={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                  </button>
                </div>
                <ErrorMessage name="password">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>
              <div className="form-group mb-2">
                <label htmlFor="nike_name" className="form-label mb-0">
                  Nike Name <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Field
                    type="nike_name"
                    id="nike_name"
                    name="nike_name"
                    placeholder="Enter your nike name"
                    className={`form-input ${errors.nike_name && touched.nike_name ? "input-error" : ""}`}
                  />
                </div>
                <ErrorMessage name="nike_name">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>
              <div className="form-group mb-2">
                <label htmlFor="location" className="form-label mb-0">
                  Location <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Field
                    type="location"
                    id="location"
                    name="location"
                    placeholder="Enter your location"
                    className={`form-input ${errors.location && touched.location ? "input-error" : ""}`}
                  />
                </div>
                <ErrorMessage name="location">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>

              {/* Submit Button */}
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="submit"
                  className="add_admin-btn"
                  disabled={isSubmitting || isLoading}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </>
                  ) : (
                    "Save Now"
                  )}
                </button>
              </div>
            </Modal.Body>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default AddOutletUserModal;
